import { Participant } from '@zoom/videosdk'
import { PulseData } from '../Pulse/PulseData'
import { RaisedHand } from '../RaisedHand'
import { UserMic } from './UserMic'
import { useSessionParams } from '../../hooks/useSessionParams'

export const UserGeneral = (props: Participant) => {
    const { room } = useSessionParams()

    return (
        <div className="user">
            <div className="top-left">
                <UserMic {...props} />
            <span>{props.displayName}</span>
        </div>
        <div className="top-right">
            <RaisedHand {...props} />
                {room === 'teams' && <PulseData {...props} />}
            </div>
        </div>
    )
}
